import React, { createContext, useState, useContext } from 'react';
import { getColorTheme } from '../utils/theme/getColorTheme';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
	const [theme, setTheme] = useState('dark');

	let color = null;
	color = getColorTheme(theme);
	const toggleTheme = () => {
		setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
	};

	return <ThemeContext.Provider value={{ toggleTheme, color }}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);
